import React, { useState } from 'react';
import axios from 'axios';
import API_BASE_URL from "../../config";
import '../../css/adminJobs.css'; 
import { ToastContainer, toast, Zoom } from "react-toastify";

if (typeof window !== "undefined") {
  require("react-toastify/dist/ReactToastify.css");
}

const AdminJobs = () => {
  const [jobData, setJobData] = useState({
    title: '',
    description: '',
    location: '',
    salary: '',
    qualifications: ''
  });

  const handleChange = (e) => {
    setJobData({ ...jobData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await axios.post(`${API_BASE_URL}/api/jobs`, jobData, {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true,
      });

    
      toast.success("Job created successfully!", {
        position: "top-right",
        autoClose: 2000,
        transition: Zoom,
      });

      // Clear input fields
      setJobData({
        title: '',
        description: '',
        location: '',
        salary: '',
        qualifications: ''
      });

    } catch (err) {
      console.error(err);

      
      toast.error("Error creating job!", {
        position: "top-right",
        autoClose: 2000,
        transition: Zoom,
      });
    }
  };

  return (
    <div className="admin-jobs-container">
      <div className="admin-jobs-box">
        <h2>Create Job</h2>

        <form onSubmit={handleSubmit} className="admin-jobs-form">

          <input
            name="title"
            placeholder="Enter job title"
            value={jobData.title}
            onChange={handleChange}
            required
          />

          <textarea
            name="description"
            placeholder="Enter job description"
            value={jobData.description}
            onChange={handleChange}
            required
          />

          <input
            name="location"
            placeholder="Enter location"
            value={jobData.location}
            onChange={handleChange}
            required
          />

          <input
            name="salary"
            placeholder="Enter salary"
            value={jobData.salary}
            onChange={handleChange}
            required
          />

          <input
            name="qualifications"
            placeholder="Enter qualifications"
            value={jobData.qualifications}
            onChange={handleChange}
            required
          />

          <button type="submit">Create</button>
        </form>

      </div>

      
      <ToastContainer hideProgressBar />
    </div>
  );
};

export default AdminJobs;
